// collection filter
// Initialize query parameters
Shopify.queryParams = {};
let keyValue;
let queries = location.search.substr(1).split("&");

// Parse the existing URL query parameters
if (location.search.length) {
  for (let i = 0; i < queries.length; i++) {
    keyValue = queries[i].split("=");
    if (keyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(
        keyValue[1]
      );
    }
  }
}

// Get the default sort value from the active tab
let defaultSortTab = document.querySelector(".sort-tab.active");
// let defaultSortValue = defaultSortTab
//   ? defaultSortTab.getAttribute("data-value")
//   : "price-ascending";

// Ensure default sorting is applied if 'sort_by' is not in the URL
if (!Shopify.queryParams.sort_by) {
  history.replaceState(
    null,
    "",
    `?${new URLSearchParams(Shopify.queryParams).toString()}`
  );
}

// Attach event listeners to all sorting tabs
document.querySelectorAll(".sort-tab").forEach((tab) => {
  tab.addEventListener("click", function (e) {
    // Prevent default button behavior
    e.preventDefault();

    // Get the value of the clicked tab
    let value = this.getAttribute("data-value");

    // Update the query parameter with the new sort value
    Shopify.queryParams.sort_by = value;

    // Update the URL without reloading the page
    history.pushState(
      null,
      "",
      `?${new URLSearchParams(Shopify.queryParams).toString()}`
    );

    // Update the active state of the tabs
    document
      .querySelectorAll(".sort-tab")
      .forEach((tab) => tab.classList.remove("active"));
    this.classList.add("active");

    // Fetch and update the content dynamically
    fetchSortedContent();
  });
});

// Fetch sorted content dynamically
function fetchSortedContent() {
  // Get the current URL with the updated query parameters
  let currentUrl = window.location.href;

  // Fetch the updated content via AJAX
  fetch(currentUrl)
    .then((response) => {
      if (response.ok) {
        return response.text();
      }
      throw new Error("Failed to fetch content");
    })
    .then((html) => {
      // Parse the response HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Extract the new product grid (or replace this selector with your actual container)
      const newContent = doc.querySelector(".product-grid");
      const currentContent = document.querySelector(".product-grid");

      // Replace the old content with the new content
      if (newContent && currentContent) {
        currentContent.innerHTML = newContent.innerHTML;
      }
    })
    .catch((error) => {
      console.error("Error fetching sorted content:", error);
    });
}
